import React from 'react';
import ReactToPrint from 'react-to-print';
import { Button } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';

/*
 * The report Print action, as an ordinary button in the report's headline (2026-10-22).
 * It replaces the large floating orange circle each report used to pin bottom-left. Same
 * react-to-print call with the same `content` — only the trigger changed.
 *
 * `disabled` until a report is on screen: before that there is nothing to print, and
 * react-to-print would be handed an empty ref.
 */
export default function PrintButton({ content, disabled = false, label = 'Print' }) {
    const button = (
        <Button variant="outlined" size="small" startIcon={<PrintIcon />} disabled={disabled}
                aria-label="Print report">
            {label}
        </Button>
    );
    if (disabled) return button;
    return <ReactToPrint trigger={() => button} content={content} />;
}
